import { render, staticRenderFns } from "./TestConfigList.vue?vue&type=template&id=00bb2e5f"
import script from "./TestConfigList.vue?vue&type=script&lang=js"
export * from "./TestConfigList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports